import { useCallback, useEffect, useState } from "react";
import { usePoster } from "../../../../hooks/usePoster";
import logger from "../../../../utils/logger";
import type { Objection } from "./types";

export const useObjectionRequests = (selectedDate = "") => {
  const post = usePoster();
  const [objections, setObjections] = useState<Objection[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchObjections = useCallback(async () => {
    try {
      setIsLoading(true);

      const res = await post("/api/objection/get-objections", {
        date: selectedDate || "",
      });

      if (res?.status && res?.data) {
        setObjections(res.data);
      } else {
        setObjections([]);
        logger.warn("No objection requests found");
      }
    } catch (error) {
      logger.error("Error fetching objection requests:", error);
    } finally {
      setIsLoading(false);
    }
  }, [post, selectedDate]);

  useEffect(() => {
    fetchObjections();
  }, [fetchObjections]);

  return {
    objections,
    isLoading,
    refetch: fetchObjections,
  };
};
